import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useMakeSelect } from '@dbh/reselect-extra';
import SmartSection from '@dbh/smart-section';
import { ADMIN_WEBCONTROLS_REFERENCES } from '@dbh/admindev-constants';
import { createSelector } from 'reselect';
import { makeSelectTemplateCode, makeSelectSearchContext } from '@dbh/webpages-redux';
import 'prop-types';
import { makeSelectWebcontrolByReference, makeSelectWebcontrolsLoaded } from '@dbh/webcontrols-redux';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

/**
 * Returns a selector that returns the generic `CategoriesTree` navigation menu
 * or a custom "categories tree like" menu, if a custom reference is passed.
 * @param {string?} customCategoryTreeReference If passed, the selector tries
 * to get the menu with such reference, and returns its contents if found in the
 * store.
 * @return {Immutable.Map?} .
 */const makeSelectCategoriesTree=withConformsTo("makeSelectCategoriesTree",[],a=>createSelector(a?makeSelectWebcontrolByReference(a):()=>void 0,makeSelectWebcontrolByReference(ADMIN_WEBCONTROLS_REFERENCES.WEBSITE_TILES),makeSelectWebcontrolsLoaded(),(b,c,d)=>d?a&&b?b:c:void 0));var makeSelectCategoriesTree$1 = makeSelectCategoriesTree;

/**
 * Returns a selector that returns the expected navigation menu (`webcontrols`)
 * reference, of the "categories tree" menu that would be associated to pages
 * with the current template code and `idProductsQuery` (from the search context).
 * @return {string} .
 */const makeSelectCustomCategoriesTreeReference=()=>createSelector(makeSelectTemplateCode(),makeSelectSearchContext(),(a,b)=>{if(!b)return "";const c=b.get("idProductsQuery");return "CategoriesTree-"+a+"-"+c});var makeSelectCustomCategoriesTreeReference$1 = makeSelectCustomCategoriesTreeReference;

const TilesSection=/*#__PURE__*/memo(a=>{let{children:b}=a;const c=useMakeSelect(makeSelectCustomCategoriesTreeReference$1),d=useSelector(useMemo(()=>makeSelectCategoriesTree$1(c),[c]));return d?/*#__PURE__*/_jsx(SmartSection,{elements:d.get("elements"),htmlTag:d.get("htmlTag"),buttonsVisible:!1,titleWeight:"bold"},void 0,b):null});TilesSection.displayName="TilesSection",TilesSection.dbhNavigationMenuReference=ADMIN_WEBCONTROLS_REFERENCES.WEBSITE_TILES;

export { TilesSection as default, makeSelectCategoriesTree$1 as makeSelectCategoriesTree, makeSelectCustomCategoriesTreeReference$1 as makeSelectCustomCategoriesTreeReference };
